import { environment } from '../../environments/environment';
import { Injectable } from '@angular/core';

export class GlobalEndPoints {
  static GET_SHIFTS = 'GET_SHIFTS';
  static GET_HEADER_METADATA = 'GET_HEADER_METADATA';
}

@Injectable({
  providedIn: 'root',
})
export class GlobalEnvProvider {
  public svc_host = '';
  public data_gateway = '/no_output_data_service';
  public core_service = '/no_output_data_service';
  public shift_service = '/no_shift_service';
  public protocol = '';

  private env_vars: any = new Object();

  constructor() {
    if (environment.protocol) {
      this.protocol = environment.protocol;
    }

    if (environment.service_host) {
      this.svc_host = environment.service_host;
    }
    if (environment.data_gateway) {
      this.data_gateway = environment.data_gateway;
    }
    if (environment.core_service) {
      this.core_service = environment.core_service;
    }
    if (environment.core_service) {
      this.shift_service = environment.shift_service;
    }

    // register all vars
    this.registerVars();
  }

  private registerVars() {
    this.env_vars[GlobalEndPoints.GET_SHIFTS] = this.protocol + this.svc_host + this.data_gateway + '/v2/getshifts';

    this.env_vars[GlobalEndPoints.GET_HEADER_METADATA] =
      this.protocol + this.svc_host + this.data_gateway + '/api/v1/getHeaderMetadata';
  }

  public getEnvVar(arg: string): string {
    return this.env_vars[arg];
  }
}
